import moment from 'moment';

import pluralize from '../../../../common/helpers/pluralize';
import { ENROLMENT_STATUS } from '../../../../legacy/constants/enums';
import { Enrolment, SchoolHolidayTerm } from '../../../../legacy/types';

export const getStartOfTermLabel = (nextSchoolTerm: SchoolHolidayTerm, isFlexi: boolean) => {
  if (!nextSchoolTerm?.schoolTerm) {
    return undefined;
  }
  return isFlexi ? `Kick start ${nextSchoolTerm.schoolTerm}` : `Kick start ${nextSchoolTerm.schoolTerm}`;
};

export const getRevisionPeriodLabel = () => {
  return 'Get ahead of the year';
};

export const getSpecificResumptionDateLabel = (nextSchoolTerm: SchoolHolidayTerm) => {
  if (!nextSchoolTerm?.schoolTerm) {
    return undefined;
  }
  return `Resume on:`;
};

export const formatHolidayDisplayText = (currentOrUpcomingHoliday: SchoolHolidayTerm): string | undefined => {
  if (!currentOrUpcomingHoliday || !currentOrUpcomingHoliday.type || !currentOrUpcomingHoliday.state) {
    return undefined;
  }
  const holidayType = currentOrUpcomingHoliday.type;
  return `Pause during upcoming ${currentOrUpcomingHoliday?.state} ${holidayType}`;
};

export const formatSchoolTermEndDateText = (currentSchoolTerm: SchoolHolidayTerm): string | undefined => {
  return !!currentSchoolTerm?.endDate && moment(currentSchoolTerm.endDate).isValid()
    ? `${currentSchoolTerm.state} ${currentSchoolTerm.schoolTerm} ends on ${moment(currentSchoolTerm.endDate).format('MMMM D')}`
    : undefined;
};

export const formatStartOfTermText = (nextSchoolTerm: SchoolHolidayTerm): string | undefined => {
  return `Start of ${nextSchoolTerm.schoolTerm}`;
};

export const formatRevisionPeriodText = (nextSchoolTerm: SchoolHolidayTerm, daysBefore: number): string | undefined => {
  if (!nextSchoolTerm?.startDate || isNaN(daysBefore) || !moment(nextSchoolTerm.startDate).isValid()) {
    return undefined;
  }
  const startDate = moment(nextSchoolTerm.startDate).subtract(daysBefore, 'days');
  return moment(startDate).isValid() ? `${daysBefore} days before start of ${nextSchoolTerm.schoolTerm}` : undefined;
};

export const weeksBeforeStartOfTermText = (
  nextSchoolTerm: SchoolHolidayTerm,
  weeksBefore: number
): string | undefined => {
  if (!nextSchoolTerm?.startDate || isNaN(weeksBefore) || !moment(nextSchoolTerm.startDate).isValid()) {
    return undefined;
  }
  const startDate = moment(nextSchoolTerm.startDate).subtract(weeksBefore, 'weeks');
  return moment(startDate).isValid()
    ? `${weeksBefore} ${pluralize('week', weeksBefore)} before start of ${nextSchoolTerm.schoolTerm}`
    : undefined;
};

export const enrolmentWillBePaused = (enrolment: Enrolment) => {
  const { enrolmentPausedFrom, enrolmentPausedTo } = enrolment;
  return (
    !!enrolmentPausedFrom &&
    moment(enrolmentPausedFrom).isAfter(moment()) &&
    !!enrolmentPausedTo &&
    moment().isBefore(moment(enrolmentPausedTo))
  );
};

export const enrolmentIsPaused = (enrolment: Enrolment) => {
  return enrolment.enrolmentStatus === ENROLMENT_STATUS.PAUSED;
};
